import { render, staticRenderFns } from "./SamLabel.vue?vue&type=template&id=a387f280&scoped=true&"
import script from "./SamLabel.vue?vue&type=script&lang=js&"
export * from "./SamLabel.vue?vue&type=script&lang=js&"
import style0 from "./SamLabel.vue?vue&type=style&index=0&id=a387f280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a387f280",
  null
  
)

export default component.exports